module.exports = __webpack_public_path__ + "bcb5cbd761894f163e524a7670b27188.svg";